import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { isSameDay, parseISO, parse } from 'date-fns';
import { Timesheet } from '../shared/models/timesheet';

@Component({
  selector: 'pps-timesheet-action',
  template: `
    <span *ngIf="showIcon && canModifyTimeSheet()">
    <a class="action-icon p-p-1 p-mr-3 text-success" (click)="editTimesheet($event)" href="#"><i class="fas fa-edit fa-lg" pTooltip="Edit timesheet" tooltipPosition="bottom"></i></a>
    <a class="action-icon p-p-1 text-danger" (click)="deleteTimesheet($event)" href="#"><i class="fas fa-trash-alt fa-lg" pTooltip="Delete timesheet" tooltipPosition="bottom"></i></a>
    </span>
  `,
  styles: [
  ],
})
export class TimesheetActionComponent implements AgRendererComponent {
  params: ICellRendererParams;
  showIcon: boolean = true;
  timesheet: Timesheet;

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.timesheet = params.data;
    this.showIcon = this.timesheet.id > 0;
    this.params = params;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  editTimesheet(evt){
    evt.preventDefault();
    this.params.context.componentParent.openTimesheetForm(this.params.data);
  }

  deleteTimesheet(evt){
    evt.preventDefault();
    this.params.context.componentParent.deleteTimesheet(this.params.data);
  }

  canModifyTimeSheet(){
    let day = this.params.data.day;
    let today = new Date();
    if ((isSameDay(day, today) && this.params.context.componentParent.canModifyTimeSheet()) ||
      this.params.context.componentParent.canModifyPastTimeSheet()){
      return true;
    }

    return false;
  }
}

